import { render, staticRenderFns } from "./FormBackButton.vue?vue&type=template&id=0e5f710f&scoped=true"
import script from "./FormBackButton.vue?vue&type=script&lang=ts"
export * from "./FormBackButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e5f710f",
  null
  
)

export default component.exports